<template>
  <div class="teacher">
    <Header />
    <Nav />
    <div class="teacher-banner">
      <img src="../assets/teacher/banner.png" alt="">
    </div>
    <div class="pages">
      <div class="teacher-container">
      <div class="teacher-menu">
        宏云课堂
        <img src="../assets/icon/right-gray.svg" alt="">
        讲师列表
      </div>
      <div class="teacher-list">
        <div class="teacher-item">
          <div class="left"><img src="../assets/teacher/head.png" alt=""></div>
          <div class="right">
            <div class="teacher-item-go">
              <span>进入主页</span>
              <img src="../assets/teacher/go.svg" alt="">
            </div>
            <div class="teacher-item-user">
              <img src="../assets/teacher/name.png" alt="">
              <h4>吴小明&nbsp;&nbsp;<span>&nbsp;&nbsp;政府采购专家</span></h4>
            </div>
            <div class="teacher-item-introduce">
              <h6><img src="../assets/teacher/user.svg" alt="">个人介绍</h6>
              <p>曾作为中国代表团成员参加WTO政府采购协议谈判。中国政府采购研究所特聘专家，中国政府采购年鉴、中国政府采购网编委。出版个人专著《政府采购法律法规、实务操作与案例解析》，主编《政府采购基础知识》</p>
            </div>
            <div class="teacher-item-book">
              <h6><img src="../assets/teacher/book.svg" alt="">精品课程</h6>
              <ul>
                <li><img src="../assets/teacher/play.svg" alt="">解读《检验检测机构资质认定生态环诗词大赛…</li>
                <li><img src="../assets/teacher/play.svg" alt="">解读《检验检测机构资质认定生态环诗词大赛…</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="teacher-item">
          <div class="left"><img src="../assets/teacher/head1.png" alt=""></div>
          <div class="right">
            <div class="teacher-item-go">
              <span>进入主页</span>
              <img src="../assets/teacher/go.svg" alt="">
            </div>
            <div class="teacher-item-user">
              <img src="../assets/teacher/name.png" alt="">
              <h4>姜爱华&nbsp;&nbsp;<span>&nbsp;&nbsp;经济学博士</span></h4>
            </div>
            <div class="teacher-item-introduce">
              <h6><img src="../assets/teacher/user.svg" alt="">个人介绍</h6>
              <p>中央财经大学财政税务学院教授，博士生导师，经济学博士，财政学国家级教学团队成员，北京市青年教学名师，中国财政学会理事。近年来主要研究领域为政府采购理论与政策、政府购买服务。</p>
            </div>
            <div class="teacher-item-book">
              <h6><img src="../assets/teacher/book.svg" alt="">精品课程</h6>
              <ul>
                <li><img src="../assets/teacher/play.svg" alt="">解读《检验检测机构资质认定生态环诗词大赛…</li>
                <li><img src="../assets/teacher/play.svg" alt="">解读《检验检测机构资质认定生态环诗词大赛…</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="teacher-list m-t-24">
        <div class="teacher-item">
          <div class="left"><img src="../assets/teacher/head2.png" alt=""></div>
          <div class="right">
            <div class="teacher-item-go">
              <span>进入主页</span>
              <img src="../assets/teacher/go.svg" alt="">
            </div>
            <div class="teacher-item-user">
              <img src="../assets/teacher/name.png" alt="">
              <h4>汤骏&nbsp;&nbsp;<span>&nbsp;&nbsp;工学硕士</span></h4>
            </div>
            <div class="teacher-item-introduce">
              <h6><img src="../assets/teacher/user.svg" alt="">个人介绍</h6>
              <p>南通市公共资源交易中心副主任。工学硕士，高级工程师，长期从事工程管理和招投标服务和信息化工作，在《中国标准化》、《中国管理信息化》、《招标采购管理》、《中国招标》、《公共采购》等期刊发表论文12篇。</p>
            </div>
            <div class="teacher-item-book">
              <h6><img src="../assets/teacher/book.svg" alt="">精品课程</h6>
              <ul>
                <li><img src="../assets/teacher/play.svg" alt="">解读《检验检测机构资质认定生态环诗词大赛…</li>
                <li><img src="../assets/teacher/play.svg" alt="">解读《检验检测机构资质认定生态环诗词大赛…</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="teacher-item">
          <div class="left"><img src="../assets/teacher/head3.png" alt=""></div>
          <div class="right">
            <div class="teacher-item-go">
              <span>进入主页</span>
              <img src="../assets/teacher/go.svg" alt="">
            </div>
            <div class="teacher-item-user">
              <img src="../assets/teacher/name.png" alt="">
              <h4>李德华&nbsp;&nbsp;<span>经济学硕士</span></h4>
            </div>
            <div class="teacher-item-introduce">
              <h6><img src="../assets/teacher/user.svg" alt="">个人介绍</h6>
              <p>副教授、硕士生导师，工程管理本科、经济法学硕士、民商法学博士（建设法方向）。任住建部执业资格注册中心特聘顾问、中国招标投标协会特聘顾问...</p>
            </div>
            <div class="teacher-item-book">
              <h6><img src="../assets/teacher/book.svg" alt="">精品课程</h6>
              <ul>
                <li><img src="../assets/teacher/play.svg" alt="">解读《检验检测机构资质认定生态环诗词大赛…</li>
                <li><img src="../assets/teacher/play.svg" alt="">解读《检验检测机构资质认定生态环诗词大赛…</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from "../components/Fixed.vue";
export default {
  name: "Teacher",
  components: {
    Header,
    Nav,
    Footer,
    Fixed
  },
};
</script>

<style lang="less" scoped>
.teacher {
  &-menu {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
    img {
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &-banner {
    width: 100%;
    height: 282px;
    position: relative;
    img {
      height: 282px;
      width: 1920px;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
    }
  }
  &-container {
    width: 1300px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.06);
    border-radius: 4px;
    margin: 0 auto;
    padding: 0 78px;
    box-sizing: border-box;
    margin-top: -82px;
    position: relative;
    z-index: 1;
    padding-bottom: 200px;
  }
  &-list {
    display: flex;
    justify-content: space-between;
  }
  &-item {
    background: url(../assets/teacher/bg.png) no-repeat;
    background-size: 100% 100%;
    width: 547px;
    height: 309px;
    box-shadow: 0px 2px 16px 0px rgba(0,0,0,0.08);
    border: 1px solid #EEEEEE;
    display: flex;
    box-sizing: border-box;
    .left {
      line-height: 0;
      img {
        width: 258px;
        height: 309px;
      }
    }
    .right {
      flex: 1;
    }
    &-go {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-top: 11px;
      padding-bottom: 15px;
      padding-right: 30px;
      span {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FF7E20;
        line-height: 20px;
        margin-right: 4px;
      }
      img {
        width: 12px;
        height: 12px;
      }
    }
    &-user {
      position: relative;
      left: -40px;
      img {
        width: 295px;
        height: 55px;
      }
      h4 {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 28px;
        position: absolute;
        top: 8px;
        left: 29px;
        span {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 20px;
        }
      }
    }
    &-introduce {
      h6 {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202429;
        line-height: 17px;
        display: flex;
        align-items: center;
        img {
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }
      }
      p {
        width: 236px;
        height: 90px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #586470;
        line-height: 18px;
        margin-top: 6px; 
        margin-left: 23px;   
      }
    }
    &-book {
      h6 {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202429;
        line-height: 17px;
        display: flex;
        align-items: center;
        img {
          width: 18px;
          height: 18px;
          margin-right: 6px;
        }
      }
      ul {
        margin-left: 23px;
        margin-top: 9px;
        li {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 14px;
          display: flex;
          align-items: center;
          margin-bottom: 4px;
          img {
            width: 12px;
            height: 12px;
            margin-right: 2px;
          }
        }
      }
    }
  }
}
.m-t-24 {
  margin-top: 24px;
}
</style>